module.exports = __webpack_public_path__ + "media/images/places/map_pin-dccacb587bb41d0b8d7179126469ed95.svg";